/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MotivoRejeicaoAliases {
  FETCH_CONSULTA = 'fetch-consulta',
  FIELD_MOTIVO = 'field-motivo',
  FIELD_OBSERVACAO = 'field-observacao',
  FORM_MOTIVO = 'form-motivo',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  PANEL_0 = 'panel-0',
}
export { MotivoRejeicaoAliases };
